import { render, staticRenderFns } from "./OtpSettingIframe.vue?vue&type=template&id=aa43475c&"
import script from "./OtpSettingIframe.vue?vue&type=script&lang=ts&"
export * from "./OtpSettingIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports